export default __webpack_public_path__ + "resources/icons/d422-e1ea.webp";